const VISUALIZATION_HEADER_HTML_ID = 'visualization-header';
const VISUALIZATION_HEADER_HEIGHT = 40;

export { VISUALIZATION_HEADER_HEIGHT, VISUALIZATION_HEADER_HTML_ID };
